import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';
import { DateTime, Duration } from 'luxon';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzTableModule } from 'ng-zorro-antd/table';
import { ToLocaleFormat } from '../../basic/pipes/to-locale-format.pipe';
import { TruncatePipe } from '../../basic/pipes/truncate.pipe';
import { Session } from '../../core/session/session';
import { SessionService } from '../../core/session/session.service';
import { BoardIconComponent } from '../../domain/board/board-icon/board-icon.component';
import { NewEditProductComponent } from '../../domain/product/new-edit-product/new-edit-product.component';
import { BasicPageComponent } from '../_shared/basic-page/basic-page.component';

@Component({
  selector: 'app-leaderboard',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,

    NzInputModule,
    NzIconModule,
    NzButtonModule,
    NzTableModule,
    NzPopoverModule,
    NzModalModule,
    NzAlertModule,
    NzPopconfirmModule,

    TruncatePipe,
    ToLocaleFormat,

    MatTooltip,

    BasicPageComponent,
    NewEditProductComponent,
    BoardIconComponent,
  ],
  templateUrl: './leaderboard.component.html',
  styleUrl: './leaderboard.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeaderboardComponent {
  startTime = DateTime.now().minus({ weeks: 4 });
  endTime = DateTime.now();

  sessionList = signal<Session[]>([]);

  constructor(private sessionService: SessionService) {
    this.sessionService.getRecentSessionList$(Duration.fromDurationLike({ weeks: 4 })).subscribe((sessionList) => {
      this.sessionList.set(sessionList);
    });
  }
}
